import axios from 'axios';
import { app } from '@/vendors/firebase/firebase';
import productsTransformer from './productsTransformer';

export default {
  async list(suppliers, id, token) {
    console.log('TOKEN IN SERVICE: ', token);
    if (process.env.VUE_APP_TYPE !== 'FL') {
      const res = [];
      const snapshot = await app.firestore()
        .collection('products')
        .where('supplier', 'in', suppliers)
        .get();
      snapshot.forEach((doc) => {
        res.push(productsTransformer.transformOne(doc.data()));
      });
      return productsTransformer.transformList(res);
    }
    if (token) {
      return axios.get(`${process.env.VUE_APP_BASE_URL_BOFL}/api/v1/store/${id}/products`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          console.log(response.data);
          return productsTransformer.transformListFL(response.data);
        }, (error) => {
          console.log(error);
        });
    }
    const res = [];
    const snapshot = await app.firestore()
      .collection('products')
      .where('supplier', 'in', suppliers)
      .get();
    snapshot.forEach((doc) => {
      res.push(productsTransformer.transformOne(doc.data()));
    });
    return productsTransformer.transformList(res);
  },
};
